// extracted by mini-css-extract-plugin
module.exports = {"container":"Profile_container__20IKd","light":"Profile_light__-4jRo","head":"Profile_head__2nUob","subTitleText":"Profile_subTitleText__243X6","links":"Profile_links__2XVSK"};